<template>
  <div class="imageInfo-wrap">
    <div class="imageInfo">
      <div class="image-header" v-if="images.length>0">
          <div class="item-wrap" v-for="(item,index) in images" :key="index">
            <img :src="item" alt="" >
          </div>
      </div>
      
    </div>
  </div>

</template>

<script>
export default {
    name:"ImageInfo",
    props: {
        images: Array,
    },
}
</script>

<style lang="less">
  .imageInfo-wrap{
    margin-bottom: 300px;
    .imageInfo{
      // position: absolute;
      // left: -40px;
      // top: 0;
      margin-left: -40px;

      .item-wrap{
        img{
          width:100vw;
          object-fit: cover;
        }
      }
    }
  }
</style>